import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { deleteShippingCategory } from "../../../../../services/Admin/ShippingCategoriesApi";

const DeleteShippingCategoryDialog = ({ open, onClose, onSuccess, category }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    setError("");
    setLoading(true);
    try {
      const res = await deleteShippingCategory(category?.id);
      if (res?.success) {
        onSuccess?.();
        onClose();
      } else {
        setError(res?.message || "فشل حذف الشريحة");
      }
    } catch (err) {
      setError(err?.message || "حدث خطأ أثناء الحذف");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>تأكيد الحذف</DialogTitle>
      <DialogContent>
        <Typography>
          هل أنت متأكد من حذف الشريحة <strong>"{category?.name}"</strong>؟
        </Typography>
        {error && (
          <Typography color="error" variant="body2" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          إلغاء
        </Button>
        <Button variant="contained" color="error" onClick={handleDelete} disabled={loading}>
          {loading ? <CircularProgress size={20} /> : "حذف"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteShippingCategoryDialog;
